import { Component, inject, Input } from "@angular/core";
import { EncounterTypeEligibilitySummary } from "app/core/models/encounter-type-eligibility-summary.model";
import { DatePipe, NgClass } from "@angular/common";
import { BlankValueDashPipe } from "app/shared/pipes/blank-value-dash.pipe";
import { keyedEncounterTypeEligibilityStatusOptions } from "app/core/options/encounter-type-eligibility-status.opts";
import { EncounterTypeEligibilityStatus } from "app/core/enums/encounter-type-eligibility-status.enum";
import { EncounterTypeEligibilitiesService } from "app/core/services/encounter-type-eligibilities.service";

@Component({
    selector: 'app-encounter-type-eligibility-summary-list',
    templateUrl: './encounter-type-eligibility-summary-list.component.html',
    styleUrls: ['./encounter-type-eligibility-summary-list.component.scss'],
    imports: [NgClass,
              DatePipe,
              BlankValueDashPipe]
})
export class EncounterTypeEligibilitySummaryListComponent {
  private encounterTypeEligibilityService = inject(EncounterTypeEligibilitiesService);

  @Input() encounterTypeEligibilitySummaries: EncounterTypeEligibilitySummary[];

  trackBySummary = (index: number, summary: EncounterTypeEligibilitySummary) => {
    return `${summary.clientId}-${summary.encounterType}`;
  };

  eligibilityStatuses = EncounterTypeEligibilityStatus;
  keyedEligibilityStatusOptions = keyedEncounterTypeEligibilityStatusOptions;

  onMarkEligibleClick(summary: EncounterTypeEligibilitySummary) {
    this.encounterTypeEligibilityService.markAsEligible(summary).subscribe(
      () => summary.eligibilityStatus = this.eligibilityStatuses.eligible
    );
  }

  onMarkIneligibleClick(summary: EncounterTypeEligibilitySummary) {
    this.encounterTypeEligibilityService.markAsIneligible(summary).subscribe(
      () => summary.eligibilityStatus = this.eligibilityStatuses.ineligible
    );
  }
}